
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.191 10.568L10.669.179l.909.864L1.643 11l9.968 9.957-.948.864L.191 11.432z"}})])
          )
        }
      }
    